import { useState } from "react";
import { HOUR_MS, TimelineView } from "@nexus/widget-kit";
import type { MonitoredEvent } from "./model";

const DEFAULT_SPAN = 6 * HOUR_MS;

/**
 * Where the present sits in the programme: a 6-hour window with now at its
 * first third, so what is running and what comes next share the view.
 * Panning changes the viewport, never the globally scoped dataset.
 */
export function ScheduleView({
  events,
  now,
  interactive,
  onSelect,
}: {
  events: MonitoredEvent[];
  now: number;
  interactive: boolean;
  onSelect: (event: MonitoredEvent) => void;
}) {
  const [span, setSpan] = useState(DEFAULT_SPAN);
  const [center, setCenter] = useState(now + DEFAULT_SPAN / 6);
  return (
    <TimelineView
      events={events}
      nowMs={now}
      spanMs={span}
      centerMs={center}
      labelMode="absolute"
      onCenterChange={setCenter}
      onSpanChange={setSpan}
      onJumpToNow={() => setCenter(now + span / 6)}
      interactive={interactive}
      onSelectEvent={(event) => {
        const selected = events.find((item) => item.event_id === event.event_id);
        if (selected) onSelect(selected);
      }}
    />
  );
}
